(function(global) {
    'use strict';

    /*
     * Make sticky sidebar and create anchor items.
     * Need require hcSticky library /vendor/jquery.hc-sticky.js/.
     *
     * @param {object} option
     *   @param {object} sidebarWrap - Wrap sidebar for hc-sticky plugin
     *   @param {object} contentWrap - Page content wrapper
     *   @param {object} anchorWrap - Acnhor wrap for create elements
     *   @param {object} menuItem - Item links sidebar
     *   @param {Number} durationScroll
     * @param {string} textAnchor
     */
    function StickySidebar(options) {
        this.options = options;
        this.textAnchor = '';
    }

    StickySidebar.prototype.init = function() {
        this.createAnchors();
        this.makeStickyBar();
    };

    /*
     * Get text for anchors from content-page and
     * Create anchors elem for sidebar
     */
    StickySidebar.prototype.createAnchors = function() {
        this.options.contentWrap.find('a[id]').each(
            function(index, element) {
                this.textAnchor = $(element).closest(
                    'p, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6'
                )[0].textContent;
                const localePrefix = global.getPathLocale();
                const pathnameWithoutLocale = location.pathname.replace(localePrefix, '');

                this.options.menuItem
                    .filter('[data-path="' + pathnameWithoutLocale + '"]')
                    .find(this.options.anchorWrap)
                    .append(
                        $('<li/>').wrapInner(
                            $('<a/>', {
                                text: this.textAnchor.replace(/(^\s?\d{1,}\. )|(\n\s?\d{1,}\. )/, '', this.textAnchor),
                                href: '#' + element.id
                            }).on(
                                'click',
                                function(eventClick) {
                                    eventClick.preventDefault();

                                    $.scrollTo($('#' + element.id), this.options.durationScroll, {
                                        offset: {
                                            top: -90
                                        }
                                    });
                                }.bind(this)
                            )
                        )
                    );
            }.bind(this)
        );
    };

    /*
     * Make sidebar fix when scrolling
     * Used library hcSticky, see https://github.com/somewebmedia/hc-sticky/
     */
    StickySidebar.prototype.makeStickyBar = function() {
        this.options.sidebarWrap.hcSticky({
            top: 75
        });
    };

    global.StickySidebar = StickySidebar;
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/components/stickySidebar.js